/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileAnalyticsHistogram } from '../../models/profile-analytics-histogram';

export interface GetProfileRank$Params {
  id: number;
}

export function getProfileRank(http: HttpClient, rootUrl: string, params: GetProfileRank$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileAnalyticsHistogram>> {
  const rb = new RequestBuilder(rootUrl, getProfileRank.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileAnalyticsHistogram>;
    })
  );
}

getProfileRank.PATH = '/rest/profile/{id}/analytics/rank';
